import React from "react";

import "./styles.scss"
import ChatInsightsMain from "../../esg-chat/insights";

const InvestorInsights = () => {
    return (
        <ChatInsightsMain model="Investor" />
    )
}

export default InvestorInsights